import type React from 'react';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import Linker from 'app/shared/modules/Linker';
import { yieldCallback } from '@zillow/yield-callback';
import ExperimentConstants from 'app/shared/constants/ExperimentConstants';
import type { RootReduxState } from 'app/shared/flux/reducers';
import 'app/shared/modules/navigation/header/HeaderNavMenuItem.scss';

interface HeaderNavMenuItemProps {
  active?: boolean;
  escape?: boolean;
  mainLinkUrl?: string;
  children: React.ReactNode;
  onClick?: () => void;
}

const HeaderNavMenuItem: React.FC<HeaderNavMenuItemProps> = ({ active, escape, mainLinkUrl, children, onClick }) => {
  const yieldTransitionTo = yieldCallback((url: string) => {
    window.router.transitionTo(url);
  });

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (escape) {
      return;
    }

    if (onClick) {
      onClick();
      return;
    }

    e.preventDefault();
    if (mainLinkUrl) {
      yieldTransitionTo(mainLinkUrl);
    }
  };

  const linkerCss = cx({
    'HeaderNavMenuItem-item': true,
    active,
  });

  // Default behavior: strip query parameters for clean hover URLs
  let displayUrl = (mainLinkUrl || '').split('?')[0];

  // HPWEB-6595: Apartment Condo A/B Test - START (Remove after experiment)
  {
    const runningExperiments = useSelector((state: RootReduxState) => state.analytics?.runningExperiments);
    const apartmentCondoExperiment = runningExperiments?.[ExperimentConstants.HOTPADS_WEB_APARTMENT_CONDO_SRP];
    const isInExperiment =
      apartmentCondoExperiment?.treatment === 'variant1' || apartmentCondoExperiment?.treatment === 'variant2';

    if (isInExperiment) {
      displayUrl = mainLinkUrl || ''; // Preserve query params for experiment users
    }
  }
  // HPWEB-6595: Apartment Condo A/B Test - END

  return (
    <li className="HeaderNavMenuItem">
      <Linker
        disabled={active}
        className={linkerCss}
        escape={escape}
        to={displayUrl}
        onClick={handleClick}
        linkType="inherit"
      >
        {children}
      </Linker>
    </li>
  );
};

export default HeaderNavMenuItem;
